import React from 'react';

export function premiumBadge(text, modifierClass) {
  return <span className={`os-premium-badge ${modifierClass || 'os-badge--gray'}`}>{text}</span>;
}

export function renderSituacaoBadge(ativo, opcoes = {}) {
  const ativoLabel = opcoes.ativoLabel || 'Ativa';
  const inativoLabel = opcoes.inativoLabel || 'Inativa';
  return premiumBadge(ativo ? ativoLabel : inativoLabel, ativo ? 'os-badge--green' : 'os-badge--gray');
}

export function filtrarPorTexto(itens, campos, termo) {
  const busca = String(termo || '')
    .trim()
    .toLowerCase();
  if (!busca) return itens;
  return itens.filter(item =>
    campos.some(campo => {
      const valor = item[campo];
      return (valor !== null && valor !== undefined) && String(valor).toLowerCase().includes(busca);
    }),
  );
}

export function filtrarPorAtivo(itens, filtroAtivo) {
  if (filtroAtivo === '') return itens;
  const esperado = filtroAtivo === '1';
  return itens.filter(item => !!item.ativo === esperado);
}
